var _metadata, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1280.000000pt",
    height: "1280.000000pt",
    viewBox: "0 0 1280.000000 1280.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.15, written by Peter Selinger 2001-2017\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,1280.000000) scale(0.100000,-0.100000)",
    fill: "white",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6319 9167 c-20 -8 -52 -23 -70 -35 -19 -12 -581 -569 -1250 -1239 -1340 -1341 -1254 -1247 -1254 -1376 0 -100 -11 -97 371 -97 l324 0 2 -1292 c3 -1203 4 -1296 20 -1331 28 -62 73 -111 130 -143 l53 -29 490 -3 c537 -3 548 -2 613 54 79 67 76 45 82 629 l5 520 23 45 c33 63 76 105 136 132 50 23 56 23 406 23 349 0 356 0 405 -23 63 -29 100 -64 133 -127 l27 -50 5 -520 c6 -584 3 -562 82 -629 65 -56 76 -57 613 -54 487 3 490 3 532 26 57 30 105 80 134 138 l24 49 3 1293 2 1292 324 0 c383 0 371 -3 371 97 -1 130 86 34 -1258 1380 -884 885 -1234 1229 -1270 1249 -59 32 -153 41 -208 21z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.941e68959c7e2fd93742a5ed57a86468.svg";
export { ForwardRef as ReactComponent };